import { PlusIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

interface Props {
  onFieldShow: () => void;
}

function AddInternalName({ onFieldShow }: Props) {
  return (
    <>
      <PlusIcon color="teal" size="sm" className="cursor-pointer" onClick={onFieldShow} />
      <Typography
        color="teal"
        variant="caption"
        fontWeight="semibold"
        className="ml-1 cursor-pointer"
        onClick={onFieldShow}
      >
        <T kind="Add Internal Name" />
      </Typography>
    </>
  );
}

export default observer(AddInternalName);
